import Version1View from './results/Version1View';
import type { FindPublishedPlan, PublishPlanArgs } from './results/publishPlan';
import { CurrencyProvider } from '../lib/currency';
import type {
  CalculationResult,
  ClientProfile,
  Model,
  ScenarioWorkspace,
  StaffPlan,
} from '@rc/engine/types';

interface Props {
  model: Model;
  result: CalculationResult;
  profile: ClientProfile;
  /** Optional — the actual staff plan linked to this scenario. When present
   *  it powers the Version 1 actual-vs-modeled comparison card. */
  staffPlan?: StaffPlan | null;
  /** Basic vs Advanced editor mode — locks automation basis and hides modeled chrome. */
  workspace?: ScenarioWorkspace;
  clientId?: string;
  geoclientId?: string;
  /** Optional patcher for scenario.profile updates initiated from the output
   *  view (e.g. saving Automation Impact deployment settings). When omitted
   *  the output cards stay read-only. */
  onProfileChange?: (patch: Partial<ClientProfile>) => void;
  /** Optional — publishes an output matrix (Modeled, Modeled-Adjusted or Future
   *  State) to the client workspace as a saved staff plan. */
  onPublishPlan?: (args: PublishPlanArgs) => Promise<void>;
  /** Resolves which saved plan a matrix would update in place. */
  findPublishedPlan?: FindPublishedPlan;
  defaultPlanName?: string;
}

export default function ResultsView({
  model,
  result,
  profile,
  staffPlan,
  workspace = 'advanced',
  clientId,
  geoclientId,
  onProfileChange,
  onPublishPlan,
  findPublishedPlan,
  defaultPlanName,
}: Props) {
  return (
    <div className="card overflow-hidden">
      <div className="p-4 space-y-4 bg-slate-50/40">
        <CurrencyProvider model={model}>
          <Version1View
            model={model}
            result={result}
            profile={profile}
            staffPlan={staffPlan}
            workspace={workspace}
            clientId={clientId}
            geoclientId={geoclientId}
            onProfileChange={onProfileChange}
            onPublishPlan={onPublishPlan}
            findPublishedPlan={findPublishedPlan}
            defaultPlanName={defaultPlanName}
          />
        </CurrencyProvider>
      </div>
    </div>
  );
}
